<script>
import options from './TestimonialCard.options'
const componentOptions = options
export default componentOptions
</script>

<template>
  <article class="be-testimonial-card">

      <div class="be-testimonial-card__content-wrapper">
 
        <blockquote class="be-testimonial-card__blockquote">

          <div class="be-icon be-testimonial-card__blockquote-icon">
            <svg role="presentation" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.093 24.453c-4.16-7.29-.005-16.919 8.055-20.09l.842 1.644C7.894 7.62 3.69 12.48 5.153 16.873c3.676-2.937 9.76-.135 9.46 4.657.134 6.103-8.517 7.978-11.52 2.922Zm15.923 0c-4.163-7.29-.006-16.919 8.054-20.09l.843 1.644c-4.098 1.612-8.298 6.47-6.838 10.866 3.677-2.937 9.76-.135 9.46 4.657.134 6.103-8.515 7.978-11.519 2.922Z" fill="#000"/></svg>
          </div>

          <p class="be-font-paragraph-1 be-testimonial-card__blockquote-quote">{{result.quote}}</p>

          <div class="be-testimonial-card__author-wrapper">
            <template v-if="result?.portraitPicture?.src">
              <figure class="be-image be-image--1-1 be-testimonial-card__author-image">
                  <img :src="result.portraitPicture.src" :alt="result?.portraitPicture?.alt">
              </figure>
            </template>
            <div class="be-testimonial-card__author-texts">
              <p class="be-font-paragraph-2 be-testimonial-card__author">{{result.author}}</p>
              <p class="be-font-highlight be-testimonial-card__author-title">{{result.authorTitle}}</p>
            </div>
          </div>

        </blockquote>

        <template v-if="result?.logoSrc">
          <figure class="be-testimonial-card__logo-image">
              <img :src="result.logoSrc" :alt="result.logoAlt">
          </figure>
        </template>

        <template v-if="result?.logoSvg">
          <figure class="be-testimonial-card__logo-svg-wrapper" >
             <div class="be-testimonial-card__logo-svg-container-div" v-html="result.logoSvg"></div>
              <p class="be-visually-hidden">{{result.logoAlt}}</p>
          </figure>
        </template>

        <template v-if="result?.ctaLinkUrl && result?.ctaLinkText">
          <a class="be-font-link be-font-link-3 be-testimonial-card__cta-link" :href="result.ctaLinkUrl">{{result.ctaLinkText}}</a>
        </template>

      </div>

    
  </article>
</template>
